export const about_items = [
  {
    title: "The Company",
    description:
      "JK Millennium Computer Centre is an Information & Communication Technology (ICT) company in Kuching, Sarawak which provides a single source of expertise and valued propositions to its customers in East Malaysia.",
  },
  {
    title: "History",
    description:
      "JK Millenium was incorporated in the year 2000 as a partnership company.",
  },
  {
    title: "Mission",
    description:
      "Our mission is to provide the best quality products and services to our customers.",
  },
];

export const auth_reseller_list = [
  "/images/auth-reseller/access.png",
  "/images/auth-reseller/acer.png",
  "/images/auth-reseller/apc.png",
  "/images/auth-reseller/asus.png",
  "/images/auth-reseller/autocount.png",
  "/images/auth-reseller/brother.png",
  "/images/auth-reseller/camnix.png",
  "/images/auth-reseller/dahua.png",
  "/images/auth-reseller/dell.png",
  "/images/auth-reseller/epson.png",
  "/images/auth-reseller/grandstream.png",
  "/images/auth-reseller/hp.png",
  "/images/auth-reseller/kaspersky.png",
  "/images/auth-reseller/microsoft.png",
  "/images/auth-reseller/neuropower.png",
  "/images/auth-reseller/panda.png",
  "/images/auth-reseller/sophos.png",
  "/images/auth-reseller/tp-link.png",
];

export const product_lists = [
  {
    id: 1,
    name: "Desktop",
    brands: [
      {
        name: "Acer Desktop",
        image: "/images/item-image/desktops/acer.png",
        link: "",
      },
      {
        name: "Asus Desktop",
        image: "/images/item-image/desktops/asus.png",
        link: "",
      },
      {
        name: "Dell Desktop",
        image: "/images/item-image/desktops/dell.png",
        link: "",
      },
      {
        name: "HP Desktop",
        image: "/images/item-image/desktops/hp.png",
        link: "",
      },
      {
        name: "Custom Built",
        image: "/images/item-image/desktops/custom.png",
        link: "",
      },
    ],
  },
  {
    id: 2,
    name: "Laptop",
    brands: [
      {
        name: "Acer",
        image: "/images/item-image/laptops/acer.png",
        link: "",
      },
      {
        name: "Asus",
        image: "/images/item-image/laptops/asus.png",
        link: "",
      },
      {
        name: "Dell",
        image: "/images/item-image/laptops/dell.png",
        link: "",
      },
      {
        name: "HP",
        image: "/images/item-image/laptops/hp.png",
        link: "",
      },
    ],
  },
  {
    id: 3,
    name: "Printer and Scanner",
    brands: [
      {
        name: "Brother",
        image: "/images/item-image/printers/brother.png",
        link: "",
      },
      {
        name: "Canon",
        image: "/images/item-image/printers/canon.png",
        link: "",
      },
      {
        name: "Epson",
        image: "/images/item-image/printers/epson.png",
        link: "https://www.epson.com.my/printer-page",
      },
    ],
  },
  {
    id: 4,
    name: "Projector",
    brands: [
      {
        name: "Acer",
        image: "/images/item-image/projectors/acer.png",
        link: "",
      },
      {
        name: "BenQ",
        image: "/images/item-image/projectors/benq.png",
        link: "https://www.benq.com/en-my/projector.html",
      },
      {
        name: "Epson",
        image: "/images/item-image/projectors/epson.png",
        link: "https://www.epson.com.my/projector-page",
      },
    ],
  },
  {
    id: 5,
    name: "Software",
    brands: [
      {
        name: "AutoCount",
        image: "/images/item-image/software/autocount.png",
        link: "https://www.autocountsoft.com",
      },
      {
        name: "Sage UBS",
        image: "/images/item-image/software/sage.png",
        link: "https://www.sage.com/en-my/",
      },
      {
        name: "Microsoft Office",
        image: "/images/item-image/software/office.png",
        link: "https://www.microsoft.com/en-my/microsoft-365/microsoft-office",
      },
      {
        name: "Microsoft Windows",
        image: "/images/item-image/software/windows.png",
        link: "https://www.microsoft.com/en-us/windows?r=1",
      },
      {
        name: "Panda Antivirus",
        image: "/images/item-image/software/panda.png",
        link: "",
      },
      {
        name: "Kaspersky Antivirus",
        image: "/images/item-image/software/kaspersky.png",
        link: "",
      },
      {
        name: "Sophos Antivirus",
        image: "/images/item-image/software/sophos.png",
        link: "https://www.sophos.com/en-us/products/endpoint-antivirus",
      },
    ],
  },
  {
    id: 6,
    name: "Accessories",
    brands: [
      {
        name: "Cables",
        image: "/images/item-image/accessories/cables.png",
        link: "",
      },
      {
        name: "Inkjet Ink",
        image: "/images/item-image/accessories/inks.png",
        link: "",
      },
      {
        name: "Mouse and Keyboards",
        image: "/images/item-image/accessories/mnk.png",
        link: "",
      },
      {
        name: "Ribbon",
        image: "/images/item-image/accessories/ribbon.png",
        link: "",
      },
      {
        name: "Router",
        image: "/images/item-image/accessories/router.png",
        link: "",
      },
      {
        name: "Switch",
        image: "/images/item-image/accessories/switch.png",
        link: "",
      },
      {
        name: "Storage Device",
        image: "/images/item-image/accessories/storage.png",
        link: "",
      },
      {
        name: "Toner",
        image: "/images/item-image/accessories/toner.png",
        link: "",
      },
      {
        name: "Uninterruptable power supply (UPS)",
        image: "/images/item-image/accessories/ups.png",
        link: "",
      },
      {
        name: "USB Hub",
        image: "/images/item-image/accessories/usb-hub.png",
        link: "",
      },
    ],
  },
  {
    id: 7,
    name: "Network",
    brands: [
      {
        name: "Servers",
        image: "/images/item-image/network/server.png",
        link: "",
      },
      {
        name: "Server Racks",
        image: "/images/item-image/network/racks.png",
        link: "",
      },
      {
        name: "Sophos Firewall",
        image: "/images/item-image/network/firewall.png",
        link: "https://www.sophos.com/en-us/products/next-gen-firewall",
      },
    ],
  },
  {
    id: 8,
    name: "Security",
    brands: [
      {
        name: "Access Numpads",
        image: "/images/item-image/security/access.png",
        link: "https://camnix.com.my/index.php/products/access-control/",
      },
      {
        name: "Alarm Systems",
        image: "/images/item-image/security/alarm.png",
        link: "https://camnix.com.my/index.php/products/alarm-system/",
      },
      {
        name: "Attendance Systems",
        image: "/images/item-image/security/attendance.png",
        link: "https://camnix.com.my/index.php/products/access-control/",
      },
      {
        name: "CCTV Cameras",
        image: "/images/item-image/security/cctv.png",
        link: "https://camnix.com.my/index.php/products/hd-network-surveillance-2/",
      },
      {
        name: "Video Recorders",
        image: "/images/item-image/security/recorder.png",
        link: "https://camnix.com.my/index.php/products/hd-network-surveillance-2/hd-network-surveillance-nvr/",
      },
    ],
  },
];

export const services = [
  {
    id: 1,
    title: "Computer Supply & Setup",
    description:
      "From desktops to laptops, we provide and configure devices for all environments.",
    icon: "qlementine-icons:computer-16",
  },
  {
    id: 2,
    title: "CCTV Surveillance",
    description:
      "Professional installation and support for modern security camera systems.",
    icon: "ph:security-camera-light",
  },
  {
    id: 3,
    title: "Alarm & Security Systems",
    description:
      "Secure your premises with smart alarms, motion detectors, and control panels.",
    icon: "mdi:security",
  },
];
